import JobsList from "./jobsList"

export default JobsList
